// extracted by mini-css-extract-plugin
export default {"container":"Stats_container__n1tR+"};